<pre *ngIf="content" class="json long-code" [innerHTML]="content"></pre>
<pre *ngIf="showUnknownContent && unknownContent" class="long-code">{{unknownContent}}</pre>
